import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col items-stretch justify-start" }
const _hoisted_2 = { class: "flex-1 flex justify-center items-center" }

import HeaderComponent from '@/components/HeaderComponent.vue';
import { LoaderCircle } from 'lucide-vue-next';

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent, {
      class: "flex-1 flex-grow-0",
      title: "Relatórios"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(LoaderCircle), { class: "animate-spin text-muted" })
    ])
  ]))
}
}

})